import { CARD_ERRORS, GENERIC_MESSAGES } from 'shared/constants/GenericMessages';
import { validateTarjeta } from 'shared/form/validations/ValidateTarjeta';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { FormWithValidation } from 'shared/form';

export const SearchCardForm = (props: {
  isPrevious: boolean;
  cardNumber: string;
  searchCardNumber(data: { tarjeta: string; selectdate: string }): void;
}) => {
  const searchTarjeta = (data) => {
    props.searchCardNumber({
      selectdate: data.selectdate?.value || null,
      tarjeta: data.tarjeta,
    });
  };

  return (
    <Card>
      <Card.Header>Movimientos por Tarjeta</Card.Header>
      <Card.Body>
        <FormWithValidation onSubmit={searchTarjeta}>
          {!!props.isPrevious && (
            <Form.Group as={Row} className="mb-3" controlId="selectdate">
              <Form.Label column sm="3">
                Período
              </Form.Label>
              <Col sm="9">
                <FormWithValidation.LegacySelect.Period
                  isSearchable={true}
                  placeholder="Seleccione un período"
                  name="selectdate"
                  registerOptions={{
                    required: GENERIC_MESSAGES.dateRequired,
                  }}
                />
                <FormWithValidation.Control.Feedback
                  type="invalid"
                  controlId="selectdate"
                />
              </Col>
            </Form.Group>
          )}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="3">
              Nro. Tarjeta:
            </Form.Label>
            <Col sm="9">
              <FormWithValidation.Control
                type="text"
                autoComplete="tarjeta"
                data-testid="tarjeta-input"
                name="tarjeta"
                registerOptions={{
                  required: CARD_ERRORS.cardNumberRequired,
                  validate: (text: string) =>
                    validateTarjeta(text) || CARD_ERRORS.cardNumberInvalid,
                }}
              />
              <FormWithValidation.Control.Feedback type="invalid" controlId="tarjeta" />
            </Col>
          </Form.Group>
          <Row>
            <Col>
              <Button variant="primary" type="submit">
                Consultar
              </Button>
            </Col>
          </Row>
        </FormWithValidation>
      </Card.Body>
    </Card>
  );
};
